<template>
  <div id="static">
    <div class="container-xl">
      <SfBreadcrumbs
        class="breadcrumbs desktop-only"
        :breadcrumbs="breadcrumbs"
      >
        <template #link="{breadcrumb}">
          <router-link :to="localizedRoute(breadcrumb.route.link)" class="sf-breadcrumbs__breadcrumb">
            {{ breadcrumb.text }}
          </router-link>
        </template>
      </SfBreadcrumbs>

      <div
        :id="content.message.includes('pagebuilder') ? 'html-body' : ''"
        :class="content.message.includes('pagebuilder') ? 'pagebuilder-container' : ''"
        v-html="content.message"
        ref="contentWrapper"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import i18n from '@vue-storefront/i18n';
import {
  SfBreadcrumbs,
  SfContentPages
} from '@storefront-ui/vue';
import { getPathForStaticPage } from 'theme/helpers';
import CmsPage from '@vue-storefront/core/pages/CmsPage';
import AStatic from 'theme/components/atoms/a-static';

export default {
  name: 'Static',
  components: {
    SfBreadcrumbs
  },
  mixins: [CmsPage],
  computed: {
    ...mapGetters({
      defaultContent: 'defaultContent/getDefaultContent'
    }),
    breadcrumbs () {
      return [
        { text: i18n.t('ruckzuck.store'), route: { link: this.localizedRoute('/') } },
        { text: this.currentRoute.title }
      ];
    },
    currentRoute () {
      return {
        isCms: true,
        title: this.$store.state.cmsPage.current.title
      }
    },
    content () {
      return this.currentRoute.isCms
        ? {
          title: this.$store.state.cmsPage.current.title,
          message: this.$store.state.cmsPage.current.content
        }
        : this.defaultContent;
    }
  },
  methods: {
    updateRoute (title) {
      /**
       * On mobile view clicking the "back" icon in SfContentPages emits click:change
       * event but without an argument. Unfortunately the same event is also used for
       * "normal" page changes so it has to be checked explicitly if it comes from "back"
       * icon or not. Currently this is the only way to do that.
       */
      if (title === undefined) {
        // "Back" icon was clicked in SfContentPages
        this.$router.back();
      } else {
        // "Normal" navigation to next page - if it exists
        const nextRoute = this.navigation.find(navigation => navigation.title === title);
        if (nextRoute) {
          this.$router.push(nextRoute.link);
        }
      }
    },
    execScripts() {
      const scripts = this.$refs.contentWrapper.querySelectorAll("script");
      scripts.forEach(oldScript => {
        const newScript = document.createElement("script");
        newScript.text = oldScript.text;
        document.body.appendChild(newScript);
        document.body.removeChild(newScript);
      });
    }
  },
  async mounted () {
    await Promise.all([
      this.$store.dispatch('defaultContent/updateDefaultContent'),
      this.execScripts()
    ])
  },
  async updated () {
    await Promise.all([
      this.execScripts()
    ])    
  }
};
</script>

<style lang="scss" scoped>
@import "~@storefront-ui/shared/styles/helpers/breakpoints";

#static {
}
::v-deep {
  .sf-bar__icon *[role=button] {
    cursor: pointer;
  }
}
</style>
